import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LinearProgressWithLabel } from './LinearProgressWithLabel';
import { client } from "../services/api";
import { toast } from "react-toastify";
import priorityLow from "../images/priority_low.png";
import priorityMedium from "../images/priority_medium.png";
import priorityHigh from "../images/priority_high.png";

function Requests({ requests, min }) {
  const navigate = useNavigate();

  const deleteRequest = async (id) => {
    if (window.confirm("The request will be deleted, continue?")) {
      const result = await client.deleteRequest(id);
      if (result.statusText === 'OK') {
        navigate('/')
      } else {
        toast.error("Request deletion failed!");
      }
    }
  }
  return (
    <div className="requests">
      {requests.map((request) => {
        let requestColor = "primary";
        if (request.status === "done") {
          requestColor = "success";
        } else if (request.status === "rejected") {
          requestColor = "error";
        }
        return (
          <div key={request._id} className={min ? "" : "section-bubble"} style={{ cursor: 'pointer' }} onClick={() => navigate(`/requests/${request._id}`)}>
            <div className="request-item">
              {min && request.form.requestPriority === "high" && <img src={priorityHigh} alt="high priority" className="request-priority-img" />}
              {min && request.form.requestPriority === "medium" && <img src={priorityMedium} alt="medium priority" className="request-priority-img" />}
              {min && request.form.requestPriority === "low" && <img src={priorityLow} alt="low priority" className="request-priority-img" />}
              <div>Request {request.form?.name}</div>
              <div>{request.project.name}</div>
              <div>{new Date(request.createDate).toLocaleDateString()}</div>
              <LinearProgressWithLabel value={Number(request.progress) || 10} color={requestColor} />
              {min && <div>{request.form.requestType.join(", ")}</div>}
              {!min && <div>{request.status || 'created'}</div>}
              {!min && (
                <div>
                  <i className="icon-remove" onClick={() => deleteRequest(request._id)}></i>
                  <a onClick={(event) => event.stopPropagation()} href={process.env.REACT_APP_URL_API+`/request/${request._id}/getReport`} target="_blank" rel="noopener noreferrer" download><i className="icon-upload"></i></a>
                </div>
              )}
            </div>
          </div>
        )}
      )}
    </div>
  );
}

export default Requests;